<template>
  <div class="tab-bar">
    <div class="tabBarContent">
      <ul class="flex">
        <li @click="useActive(1)">
          <span class="border-1px" :class="active === 1 ? 'active' : ''">历史锅底</span>
        </li>
        <li @click="useActive(2)">
          <span class="border-1px" :class="active === 2 ? 'active' : ''">私人定制</span>
        </li>
      </ul>
    </div>
    <router-view class="content"/>
  </div>
</template>
<script>
  import mainUtils from '../../pub/utils/mainUtils'

  export default {
    name: "titleBar",
    data() {
      return {
        active: 1,
        urlParams: {}
      }
    },
    methods: {
      useActive(val) {
        this.active = val;
        if (val === 1) this.$router.push({path: '/history', query: this.urlParams});
        if (val === 2) this.$router.push({path: '/customizationNew', query: this.urlParams});
      },
    },
    created() {
      if (this.$route.meta.title === "历史锅底") this.active = 1;
      if (this.$route.meta.title === "私人定制") this.active = 2;
      let _hash = window.location.hash;
      if (_hash.includes('?')) {
        this.urlParams = {};
        let pathname = window.location.hash.split('?')[1];
        pathname.split('&').map(item => {
          let _value = item.split('=');
           this.urlParams[_value[0]] = _value[1];
         });
      }
    },
    mounted() {
      document.documentElement.style.fontSize = document.documentElement.clientWidth / 8.8 + 'px';
    },
  }
</script>
<style lang="stylus" scoped>
  @import "./../../assets/css/func.styl"
  .flex
    display: flex
    background: #f3f3f3
  .tab-bar
    display: flex
    flex-direction: column
    overflow: hidden
    height: 100vh;
    font-size: .34rem
    .tabBarContent
      height: 1.2rem;
      li
        flex: 1
        text-align: center
        height: 1.2rem
        color: #272727
      span
        display inline-block
        width: 3rem
        line-height: 1.2rem
      .active
        bb-1px(#ff9800)
        color: #ff9800
        font-size: .4rem
    .content
      flex: 1
</style>


// WEBPACK FOOTER //
// src/components/taste/taste-index.vue